import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service'; // Update the import path according to your structure
import { TokenStorageService } from '../token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    private tokenStorage: TokenStorageService
  ) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {

    // Mobil OS localStorage'ı sildiyse yönlendirmeden hemen önce kurtar
    await this.authService.rescueMobileSession();

    const isAuthenticated = this.authService.isAuthenticated(); // Implement this method in AuthService

    if (!isAuthenticated) {
      return this.router.parseUrl('/login');
    }

    // C29: a picker session has no tenant — its only page is the picker.
    if (this.tokenStorage.isPickerSession()) {
      return this.router.parseUrl('/profiles');
    }

    return true;
  }
  
}
